<template>
  <div>
    <div class="container-fluid bg-content">
      <v-row>
        <v-col
          cols="12"
          sm="12"
        >
          <div class="content-button-flex-end">
            <v-btn
              @click="dialogAddDocument = true;"
              class="button-primary mon-bold"
              elevation="0"
            >
              {{ texts.warehousedetail.attachments.buttonAddDocument }}
            </v-btn>
          </div>
          <div v-if="images.length > 0">
            <div v-if="isResponsive">
              <div
                v-for="(item, index) in images"
                :key="index"
                class="content-card mt-5 pa-2"
              >
                <div class="display-flex align-items-flex-start">
                  <p class="mon-bold mb-0">{{ texts.warehousedetail.tableAttachments.headers[0] }}</p>
                  <v-spacer />
                  <p
                    style="width: 100%; overflow-wrap: break-wrap; text-align: right;"
                    class="mon-regular mb-0 ml-2"
                  >{{ item.sName }}</p>
                </div>
                <div class="display-flex align-items-flex-start mt-2">
                  <p class="mon-bold mb-0">{{ texts.warehousedetail.tableAttachments.headers[1] }}</p>
                  <v-spacer />
                  <p
                    @click="redirectURL(item.sFileUrl)"
                    class="text-title-file mb-0 ml-2"
                    style="color: #0971fb; width: 100%; overflow-wrap: break-wrap; text-align: right;"
                  >{{ item.sName }}</p>
                </div>
                <v-btn
                  elevation="0"
                  @click="setDialogDelete(item.sVendorWarehousesFileId)"
                  class="button-tertiary mt-2"
                  style="width: 100%;"
                >
                  {{
                    (selectLanguage == 'sp')
                    ? 'Eliminar'
                    : 'Delete'
                  }}
                </v-btn>
              </div>
              <div class="display-flex align-items-center justify-content-center mt-9">
                <div class="pagination-styles">
                  <v-pagination
                    v-model="iCurrentPage"
                    :length="lengthPage"
                    color="#FFC556"
                    next-icon="mdi-menu-right"
                    prev-icon="mdi-menu-left"
                  ></v-pagination>
                </div>
              </div>
            </div>
            <div
              v-else
              class="content-card mt-5 mb-9"
            >
              <div class="pa-2">
                <div>
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th
                            v-for="(item, index) in texts.warehousedetail.tableAttachments.headers"
                            :key="index"
                            :class="(item == 'Acciones' || item == 'Actions') ? 'text-right text-header-title mon-bold' : 'text-header-title mon-bold'"
                          >
                            {{ item }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in images"
                          :key="index"
                        >
                          <td class="mon-regular">{{ item.sName }}</td>
                          <td
                            class="text-title-file mon-regular"
                            @click="redirectURL(item.sFileUrl)"
                          >{{ item.sName }}</td>
                          <td :class="(texts.warehousedetail.tableAttachments.headers[2] == 'Acciones' || texts.warehousedetail.tableAttachments.headers[2] == 'Actions')  ? 'text-right': ''">
                            <v-btn
                              @click="setDialogDelete(item.sVendorWarehousesFileId)"
                              icon
                            >
                              <v-icon
                                color="#D8686A"
                                size="18px"
                              >
                                mdi-delete
                              </v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </div>
                <div class="display-flex align-items-center justify-content-center mt-9">
                  <div class="pagination-styles">
                    <v-pagination
                      v-model="iCurrentPage"
                      :length="lengthPage"
                      color="#FFC556"
                      next-icon="mdi-menu-right"
                      prev-icon="mdi-menu-left"
                    ></v-pagination>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div
            v-else
            style="height: 400px"
            class="display-flex align-items-center justify-content-center"
          >
            <p class="empty-text mon-regular">
              {{ texts.warehousedetail.attachments.textNoDocuments }}
            </p>
          </div>
          <!-- <br><br><br><br><br><br><br><br><br> -->
        </v-col>
      </v-row>
    </div>
    <!-- add documents dialog -->
    <v-dialog
      persistent
      v-model="dialogAddDocument"
      :width="screenWidth + '%'"
    >
      <div class="container-dialog">
        <close-dialog-component @closeDialog="closeDialog" />
        <p class="text-title-dialog mon-bold">{{ texts.warehousedetail.dialogAddDocument.textTitle }}</p>
        <div>
          <v-text-field
            v-model="documentName"
            type="text"
            :label="texts.warehousedetail.dialogAddDocument.textDocumentName"
            outlined
            color="#000000"
            dense
            class="global-inputs mon-regular"
            :placeholder="texts.warehousedetail.dialogAddDocument.textDocumentName"
            persistent-placeholder
          ></v-text-field>
          <v-btn
            v-if="documentLabel == ''"
            @click="$refs.inputUpload.click()"
            class="button-add-document mon-regular mt-5"
            elevation="0"
          >
            {{ texts.warehousedetail.dialogAddDocument.textDocumentLabelFile }}
            <v-icon
              class="ml-1"
              color="#707070"
              size="16px"
            >
              mdi-tray-arrow-up
            </v-icon>
            <input
              ref="inputUpload"
              style="display: none;"
              type="file"
              size="60"
              accept=".doc, .docx, .pdf"
              @change="uploadFilesWarehouse"
            >
          </v-btn>
          <div
            v-else
            class="content-file display-flex align-items-center justify-content-center mt-5"
          >
            <p class="text-file mon-regular">{{ documentLabel }}</p>
            <v-btn
              @click="deleteDocument"
              icon
            >
              <v-icon
                class="ml-2"
                color="#D8686A"
                size="18px"
              >
                mdi-delete
              </v-icon>
            </v-btn>
          </div>
        </div>
        <div
          class="mt-9 mb-5"
          style="border-bottom: 1px solid #CECECE;"
        />
        <div v-if="isResponsive">
          <v-btn
            :loading="bLoading"
            :disabled="!validateForm"
            @click="sendFileWarehouse"
            elevation="0"
            class="button-primary mon-bold"
            style="width: 100%;"
          >
            {{ texts.warehousedetail.dialogAddDocument.textButtonAdd}}
          </v-btn>
          <v-btn
            @click="closeDialog"
            elevation="0"
            class="button-secondary mon-regular mt-4"
            style="width: 100%;"
          >
            {{ texts.warehousedetail.dialogAddDocument.textButtonClose}}
          </v-btn>
        </div>
        <div
          v-else
          class="display-flex align-items-center justify-content-flex-end"
        >
          <v-btn
            @click="closeDialog"
            elevation="0"
            class="button-secondary mon-regular"
          >
            {{ texts.warehousedetail.dialogAddDocument.textButtonClose}}
          </v-btn>
          <v-btn
            :loading="bLoading"
            :disabled="!validateForm"
            @click="sendFileWarehouse"
            elevation="0"
            class="button-primary mon-bold ml-4"
          >
            {{ texts.warehousedetail.dialogAddDocument.textButtonAdd}}
          </v-btn>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "WarehouseDetailContentTabTwoLayout",
  props: {
    texts: {
      type: Object,
    },
    arr: {
      type: Object,
    },
  },
  data() {
    return {
      //VARIABLES
      images: [],
      lengthPage: 0,
      iCurrentPage: 1,
      screenWidth: 0,
      dialogAddDocument: false,
      documentName: "",
      documentLabel: "",
      documentFile: null,
      bLoading: false,
      isResponsive: false,
    };
  },
  beforeMount() {
    this.getFiles();
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    closeDialog: function () {
      this.dialogAddDocument = false;
      this.documentName = "";
      this.documentLabel = "";
      this.documentFile = null;
    },
    deleteDocument: function () {
      this.documentLabel = "";
      this.documentFile = null;
    },
    handleResize: function () {
      if (window.innerWidth >= 960) {
        this.screenWidth = 35;
      } else {
        this.screenWidth = 100;
      }

      if (window.innerWidth < 960) {
        this.isResponsive = true;
      } else {
        this.isResponsive = false;
      }
    },
    setDialogDelete: function (id) {
      this.$store.commit("setDialogDelete", {
        active: true,
        title: this.texts.warehousedetail.deleteTextDocument,
        api: `${URI}/api/v1/${this.selectLanguage}/vendors/enterprises/${this.$store.state.sEnterpriseId}/warehouses/${this.arr.sVendorWarehouseId}/files/${id}`,
        redirect: "",
      });
    },
    redirectURL: function (url) {
      window.open(url, "_blank");
    },
    getFiles: function () {
      const payload = {};

      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.sToken}`,
        },
      };

      DB.get(
        `${URI}/api/v1/${this.selectLanguage}/vendors/enterprises/${this.$store.state.sEnterpriseId}/warehouses/${this.arr.sVendorWarehouseId}/files?iPageNumber=${this.iCurrentPage}&iItemsPerPage=10`,
        config,
        payload
      )
        .then((response) => {
          this.images = response.data.results;
          this.lengthPage = response.data.iNumPages;
          this.iCurrentPage = response.data.iCurrentPage;
          this.$store.commit("refresher", false);
        })
        .catch((err) => {
          this.mixError(err.response.data.message);
        });
    },
    uploadFilesWarehouse: function (e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        if (files[0].name.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.documentLabel = files[0].name;
          this.documentFile = files[0];
          // this.sendFileWarehouse(files[0], files[0].name);
        });
      }
    },
    sendFileWarehouse: function () {
      this.bLoading = true;

      const payload = { sName: this.documentName };

      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.sToken}`,
        },
      };

      DB.post(
        `${URI}/api/v1/${this.selectLanguage}/vendors/enterprises/${this.$store.state.sEnterpriseId}/warehouses/${this.arr.sVendorWarehouseId}/files`,
        payload,
        config
      )
        .then((response) => {
          this.sendImage(response.data.results.sVendorWarehousesFileId);
        })
        .catch((err) => {
          this.bLoading = false;
          this.mixError(err.response.data.message);
        });
    },
    sendImage(id) {
      const self = this;

      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.sToken}`,
        },
      };

      var form = new FormData();
      form.append("file", this.documentFile);

      DB.patch(
        `${URI}/api/v1/${this.selectLanguage}/vendors/enterprises/${this.$store.state.sEnterpriseId}/warehouses/${this.arr.sVendorWarehouseId}/files/${id}`,
        form,
        config
      )
        .then((response) => {
          this.bLoading = false;

          this.mixSuccess(response.data.message);
          this.closeDialog();
          this.$store.commit("refresher", true);
          this.getFiles();
        })
        .catch((err) => {
          this.bLoading = false;
          this.mixError(err.response.data.message);
        });
    },
  },
  computed: {
    selectLanguage: function () {
      return this.$store.state.language;
    },
    refresh: function () {
      return this.$store.state.refresh;
    },
    validateForm: function () {
      return this.documentName !== "" && this.documentLabel !== "";
    },
  },
  watch: {
    arr: function () {
      if (this.arr) {
        this.getFiles();
      }
    },
    refresh: function () {
      this.getFiles();
    },
    iCurrentPage: function () {
      this.getFiles();
    },
  },
};
</script>

<style scoped>
.content-file {
  border: 1px dashed #707070;
  border-radius: 10px;
  padding: 0px;
}

.text-file {
  text-align: center;
  font-size: 12px;
  letter-spacing: 0px;
  color: #707070;
  margin-bottom: 0px;
}

.button-add-document {
  background: #ffffff 0% 0% no-repeat padding-box !important;
  border: 1px dashed #707070;
  border-radius: 10px;
  opacity: 1;
  text-align: center;
  font-size: 12px;
  letter-spacing: 0px;
  color: #707070;
  text-transform: initial;
  width: 100%;
}

.container-dialog {
  width: 100%;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  opacity: 1;
  padding: 25px;
  position: relative;
}

.text-title-dialog {
  text-align: center;
  letter-spacing: 0px;
  color: #283c4d;
  opacity: 1;
  font-size: 20px;
}

.text-title-file {
  text-align: left;
  font-size: 16px;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
  margin-bottom: 0px;
}

.text-title-file:hover {
  color: #0971fb;
  text-decoration: underline;
  cursor: pointer;
}

.text-documents {
  text-align: left;
  font-size: 16px;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
  margin-bottom: 0px;
}

.text-title-table {
  text-align: left;
  font-size: 16px;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
  margin-bottom: 0px;
}

.separator-line {
  border: 1px solid #cecece;
}

.content-card {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #e9e9e9;
  border-radius: 4px;
  opacity: 1;
}

.content-button-flex-end {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.v-container-fluid {
  max-width: 90%;
}

@media (max-width: 960px) {
  .v-container-fluid {
    max-width: 100%;
  }
}
</style>